import { Box, Stack } from '@mui/material'
import React from 'react'

export default function Vision() {
  return (
    <div className="bg-[#1D5DBA] py-10 bg-bottom">
      <div className="container lg:px-[10%] max-w-5xl flex flex-col items-center justify-center text-white">
        <h3 className="heading-2 min-w-[150px] text-center mb-2 text-white">
          VISION
        </h3>
        <h4>わたしたちが目指す理想</h4>
        <Stack className="my-2 flex-row">
          <Box
            component="img"
            src="/static/left-quotes.png"
            alt="left-quotes"
            className="w-8 h-8 lg:w-10 lg:h-10 object-contain"
          ></Box>
          <h4 className="font-medium text-center lg:text-xl text-lg">
            　そのため、
            <br className="block sm:hidden" />
            <span className="lg:text-3xl text-xl">
              共創型Well-being企業のプラットフォーム
            </span>
            <br />
            を目指します
          </h4>
          <Box
            component="img"
            src="/static/right-quotes.png"
            alt="left-quotes"
            className="w-8 h-8 lg:w-10 lg:h-10 object-contain"
          ></Box>
        </Stack>
        <p className="text-center pb-6">
          共創型幸福企業とは、他の組織や個人と協力して新しい価値を創造し、全体の幸福を追求する企業です。私たちは、そのための基盤や環境、サービス、商品、人材などを提供することを目指します。すべてのステークホルダーと良質な関係を築き、単独では達成しにくい目標の実現と、持続可能なホームコミュニティの拡張を通して、誰もが幸福を実感できる社会を目指していきます。​
        </p>
      </div>
    </div>
  )
}
